<template>
	<section style="overflow-y: auto;height: calc(100vh - 110px);">
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-form :inline="true" :model="filters" class="filterForm">
				<el-form-item label="段位名称:" label-width="100px">
					<el-input v-model="filters.levelName" auto-complete="off" class="formItem" size="small" />
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getGridData" size="small">查询</el-button>
					<el-button type="primary" @click="addInfo" size="small">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="grid_data" height="calc(100vh - 210px)" border highlight-current-row v-loading="listLoading"
			@selection-change="(v) => { sels = v }" style="width: 100%;">
			<el-table-column prop="levelName" label="段位名称" width="150"></el-table-column>
			<el-table-column prop="scoreNum" label="段位分值" width="150"></el-table-column>
			<el-table-column prop="addTime" label="添加时间" width="150" :formatter="$util.dateFormatEx"></el-table-column>

			<el-table-column label="操作" min-width="160">
				<template scope="scope">
					<el-button size="small" @click="editInfo(scope.$index, scope.row)">编辑</el-button>
					<el-button size="small" @click="delInfo(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--分页-->
		<pagination :totalPage="total" :currentPage="filters.page" :pageSize="filters.rows"
			@pageSizeCallBack="handleSizeChange" @currentPageCallBack="handleCurrentChange"></pagination>
		<addsave :showTitle="showTitle" :dialogAddShow="dialogAddShow" :mid="mid" @saveCallBack="saveCallBack"
			@getVisible="(v) => { dialogAddShow = v }"></addsave>
	</section>
</template>
<script>
import pagination from '@/components/common/pagination.vue'
import addsave from './levelinfoadd.vue'
export default {
	components: { addsave, pagination },
	data() {
		return {
			filters: {
				id: 0,
				levelName: '',
				rows: 10,
				page: 1
			},
			grid_data: [],
			total: 0,
			listLoading: false,
			sels: [],//列表选中列
			showTitle: "",
			dialogAddShow: false,
			mid: 0
		}
	},
	methods: {
		//获取列表
		getGridData() {
			this.listLoading = true;
			let formData = this.$util.jsonToForm(this.filters);
			this.$axios.post("/exercise/getlevelinfolist", formData).then(res => {
				this.listLoading = false;
				this.total = res.data.total;
				this.grid_data = res.data.data;
			});
		},
		//删除
		delInfo: function (index, row) {
			this.$confirm('确认删除该记录吗?', '提示', {
				type: 'warning'
			}).then(() => {
				let formData = new FormData();
				formData.append("id", row.id);
				this.$axios.post("/exercise/levelinfodel", formData).then(res => {
					if (res.data.status == 0) {
						this.$message("删除成功!");
						this.getGridData();
					} else {
						this.$message(res.data.msg);
					}
				});
			});
		},
		addInfo: function () {
			this.showTitle = "新增段位";
			this.dialogAddShow = true;
			this.mid = 0;
		},
		editInfo: function (index, row) {
			this.showTitle = "编辑段位";
			this.dialogAddShow = true;
			this.mid = row.id;
		},
		saveCallBack: function () {
			this.dialogAddShow = false;
			if (this.mid == 0) {
				this.handleCurrentChange(1);
			}
			else {
				this.getGridData();
			}
		},
	},
	async created() {
		this.getGridData();
	}
}

</script>

<style scoped></style>
